<template>
  <div class="view-154">
    <div class="rectangle-95-12"></div>
  </div>
</template>

<script>
export default {
  name: "View682",
};
</script>

<style>
.view-154,
.view-158,
.view-159,
.view-160 {
  background-color: var(--quick-silver);
  display: flex;
  height: 8px;
  left: 1204px;
  position: absolute;
  top: 768px;
  transform: rotate(90deg);
  width: 1423px;
}

.rectangle-95-12,
.rectangle-95-13,
.rectangle-95-15,
.rectangle-95-16 {
  background-color: var(--black-3);
  border-radius: 5px;
  height: 8px;
  margin-left: 31.3px;
  width: 92.16px;
}
</style>
